var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PosAngleData = require("../abstract/posAngleData.js");
var cio_config = require("cio-config");

var PadReplicatorData = function (position, angle, nCol, nRow, hPitch, vPitch, motif) {
    var self = this;

    this.makeObservableTreeNode();

    this.addPosAngle(position, angle);

    this.nCol = this.value("nCol", true, cio_config.types.positive_int.validator);
    this.nRow = this.value("nRow", true, cio_config.types.positive_int.validator);
    this.vPitch = this.value("vPitch", true, cio_config.types.positive_float.validator);
    this.hPitch = this.value("hPitch", true, cio_config.types.positive_float.validator);

    this.nameList  = this.list("nameList", true);
    this.motif = this.value("motif", true);

    this.nonTransformedSegmentedGeometry = this.cachedFunction("nonTransformedSegmentedGeometry",
        this._getNonTransformedSegmentedGeometry,
        [this.nCol, this.nRow, this.vPitch, this.hPitch, [this.motif, this.motif.onBubble]]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        function (precision) {
            return self.nonTransformedSegmentedGeometry(precision)
                .translate(self.pos())
                .rotate(self.angle(), self.pos());
        },
        [this.nonTransformedSegmentedGeometry, this.pos, this.angle]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function () {
            return self.segmentedGeometry().getBB();
        },
        [this.segmentedGeometry]
    );

    if (nCol != undefined) this.nCol(nCol);
    if (nRow != undefined) this.nRow(nRow);
    if (vPitch != undefined) this.vPitch(vPitch);
    if (hPitch != undefined) this.hPitch(hPitch);
    if (motif != undefined) this.motif(motif);
};
lib_core.mixin(PadReplicatorData, lib_core.ObservableTreeNode, PosAngleData);
lib_core.JsonParser.registerClass(PadReplicatorData, "PadReplicatorData");

module.exports = PadReplicatorData;

// PadReplicatorData.prototype.populateNameList = function() {
//     for (var i = 0; i < (this.nCol() * this.nRow()); i++) this.nameList.push(this.nameManagedType.getProposal(i+1));
// };
//
// PadReplicatorData.prototype.updateNameList = function() {
//     this.nameList.removeAll();
//     this.populateNameList();
// };

PadReplicatorData.prototype.getPads = function(absolutePositions) {
    var self = this;

    var pads = [];

    this.nameList.forEach(function(idx, name){
        var col = Math.floor(idx / self.nRow());
        var row = idx % self.nRow();
        if (col % 2 == 1) row = self.nRow() - 1 - row;   // in odd columns change order from bottom to top

        var pad = self.motif().clone();
        pad.name(name);
        pad.move(new lib_geometry.Coord((-(self.nCol() - 1) / 2 + col) * self.hPitch(),((self.nRow() + 1) / 2 - row) * self.vPitch()));
        if (absolutePositions) {
            pad.move(self.pos());
            pad.rotate(self.angle(), self.pos());
        }
        pads.push(pad);
    });

    return pads;
};

PadReplicatorData.prototype.expand = function(deterministic) {
    var self = this;

    var pads = self.getPads(true);
    var footprintdata = this.parent();
    this.remove();

    function assignDeterministicId(obj){
        footprintdata.root.registerNode(obj, self.$id + "-" + idx++);   // register node with deterministic id
        obj.forEachChild(function(child){
            if (child && child.isObservableTreeNode) assignDeterministicId(child);
        });
    }

    var idx = 0;
    pads.forEach(function(pad) {
        if (deterministic){
            assignDeterministicId(pad);
        }
        footprintdata.pads.add(pad);
    });
};

PadReplicatorData.prototype._getNonTransformedSegmentedGeometry = function (precision) {
    var w = (this.nCol()-1)*this.hPitch() + this.motif().getTopCopper().width();
    var h = (this.nRow()-1)*this.vPitch() + this.motif().getTopCopper().height();
    var poly = new lib_geometry.BoundingBox(- w/2, - h/2, w, h).getPoly();
    return poly;
};
